import {useDispatch} from "react-redux";
import React, {useState} from "react";
import {resetMenu} from "../redux/slices/menuSlice";
import EntityApi from "../api/EntityApi";
import {Badge, Button as ButtonAntd, Checkbox, message, Pagination, Space, Table} from "antd";
import {Link} from "react-router-dom";
import Input from "../components/element/Input";
import Button from "../components/element/Button";
import {ExportOutlined, SearchOutlined} from "@ant-design/icons";
import RequestApi from "../api/RequestApi";

const StatisticPage = () => {

    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [isReload, setIsReload] = useState(false);
    const [inputSearchClient, setInputSearchClient] = useState('');
    const [sortField, setSortField] = useState('id');
    const [sortOrder, setSortOrder] = useState('desc');
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [selectItems, setSelectItems] = React.useState([]);
    const [selectCount, setSelectCount] = React.useState(0);
    const [isLoadingExport, setIsLoadingExport] = useState(false);

    const onSelectItem = (checked, id) => {
        let items = selectItems;
        if (checked) {
            if (items.indexOf(id) === -1) {
                items.push(id);
            }
        } else {
            if (items.indexOf(id) !== -1) {
                items.splice(items.indexOf(id), 1);
            }
        }
        console.log(items);
        setSelectItems(items);
        setSelectCount(items.length);
    }

    const handleSearchClient = (selectedKeys, confirm) => {
        confirm();
        setIsReload(!isReload);
    }

    const handleResetClient = (confirm) => {
        setInputSearchClient('');
        confirm();
        setIsReload(!isReload);
    };

    const getColumnSearchClient = () => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div className={'p-2'}>
                <Input type='text' onChange={(value) => setInputSearchClient(value)} value={inputSearchClient} placeholder={'Номер,имя,компания'} />
                <Space className={'pt-2'}>
                    <Button text={'Найти'} type={'primary'} onClick={() => handleSearchClient(selectedKeys, confirm)}/>
                    <Button text={'Сбросить'} type={'default'} onClick={() => confirm && handleResetClient(confirm)}/>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const columns = [];
    columns.push({
        title: '',
        width: 50,
        render: (item) => <Checkbox checked={selectItems.includes(item.id)} onChange={(e) => onSelectItem(e.target.checked, item.id)}></Checkbox>
    })
    columns.push({
        title: 'Клиент',
        responsive: ['xs'],
        ...getColumnSearchClient(),
        render: (item) => {
            return <>
                <div><span className={'font-bold'}>ID: </span>{item.id}</div>
                <div><span className={'font-bold'}>Последняя активность: </span>{item.activeDt}</div>
                <div><span className={'font-bold'}>ФИО: </span>{item.surname}</div>
                <div><span className={'font-bold'}>Номер телефона: </span>{item.login}</div>
                <div><span className={'font-bold'}>Организация: </span>{item.company}</div>
                <div><span className={'font-bold'}>Новых обучений: </span>{item.statNew}</div>
                <div><span className={'font-bold'}>Обучений начато: </span>{item.statStarted}</div>
                <div><span className={'font-bold'}>Обучений завершено: </span>{item.statEnded}</div>
                <div><span className={'font-bold'}>Обучений отменено: </span>{item.statCanceled}</div>
                <div><span className={'font-bold'}>Всего обучений: </span>{item.statTotal}</div>
            </>
        }
    })
    columns.push({
        title: 'ID',
        width: 100,
        dataIndex: 'id',
        responsive: ['md'],
        sorter: true,
    });
    columns.push({
        title: 'Последняя активность',
        width: 150,
        dataIndex: 'activeDt',
        responsive: ['md'],
        sorter: true
    });
    columns.push({
        title: 'ФИО',
        //width: 300,
        dataIndex: 'surname',
        responsive: ['md'],
        sorter: true,
        ...getColumnSearchClient(),
        render: (client, data) => <Link to={'/cabinet/users/' + data.id}>{client}</Link>
    });
    columns.push({
        title: 'Номер телефона',
        //width: 300,
        dataIndex: 'login',
        responsive: ['md'],
        sorter: true,
        ...getColumnSearchClient(),
        render: (login, data) => <Link to={'/cabinet/users/' + data.id}>{login}</Link>
    });
    columns.push({
        title: 'Организация',
        //width: 300,
        dataIndex: 'company',
        responsive: ['md'],
        //sorter: true,
        ...getColumnSearchClient(),
        render: (company, data) => <Link to={'/cabinet/users/' + data.id}>{company}</Link>
    });
    columns.push({
        title: 'Новых обучений',
        width: 100,
        dataIndex: 'statNew',
        responsive: ['md'],
        sorter: true
    });
    columns.push({
        title: 'Обучений начато',
        width: 100,
        dataIndex: 'statStarted',
        responsive: ['md'],
        sorter: true
    });
    columns.push({
        title: 'Обучений завершено',
        width: 100,
        dataIndex: 'statEnded',
        responsive: ['md'],
        sorter: true
    });
    columns.push({
        title: 'Обучений отменено',
        width: 100,
        dataIndex: 'statCanceled',
        responsive: ['md'],
        sorter: true
    });
    columns.push({
        title: 'Всего обучений',
        width: 100,
        dataIndex: 'statTotal',
        responsive: ['md'],
        sorter: true
    });

    const getList = () => {
        setIsLoading(true);
        //handleIsFilter();
        EntityApi.getBy('private/statistic', {
            filter: {
                client: inputSearchClient
            },
            sort: {
                [sortField]: sortOrder
            },
            size: pageSize,
            page: page
        }).then((data) => {
            setIsLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS) {
                let items = [];
                if (data.content.items) {
                    data.content.items.forEach((content) => {

                        let item = content;
                        items.push(item);
                    });
                }
                setDataSource(items);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
        });
    }

    const onPaginate = (p) => {
        setPage(p);
        setIsReload(!isReload);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.hasOwnProperty("column")) {
            if (sorter.field !== undefined) {
                setSortField(sorter.field);
            } else {
                setSortField('id');
            }
            if (sorter.order === 'ascend') {
                setSortOrder('asc');
            }
            if (sorter.order === 'descend') {
                setSortOrder('desc');
            }
        } else {
            setSortField('id');
            setSortOrder('desc');
        }
        setIsReload(!isReload);
    }

    const onResetSelectItems = () => {
        setSelectItems([]);
        setSelectCount(0);
        setIsReload(!isReload);
    }

    const onExport = () => {
        setIsLoadingExport(true);
        let filterExport = {
            client: inputSearchClient
        }
        if (selectItems.length > 0) {
            filterExport = {ids: selectItems}
        }
        RequestApi.post('private/statistic', {
            filter: filterExport,
            sort: {
                ['id']: 'desc'
            },
            size: 100000000,
            page: 1,
            is_export: true
        }).then((data) => {
            setIsLoadingExport(false);
            if (data.status === RequestApi.STATUS_SUCCESS) {
                window.open(data.content.item.url, '_blank');
            } else {
                message.error('Ошибка выгрузки');
            }
        }).catch((error) => {
            setIsLoadingExport(false);
            message.error('Ошибка сервера');
        });
    }

    React.useEffect(() => {
        dispatch(resetMenu());
        getList();
    }, [isReload])

    return <>
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    Активность пользователей
                </h2>
            </div>
        </div>
        <div className="card px-4 pb-4">
            <div className="my-3 flex h-8 items-center justify-between">
                <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    Статистика
                </h2>
                <div className={'flex items-center'}>
                    {
                        selectCount > 0 &&
                        <div className={'pr-3'}><span className={'underline cursor-pointer'}
                                                      onClick={onResetSelectItems}>Сбросить</span> Выбрано: {selectCount}
                        </div>
                    }
                    <ButtonAntd disabled={isLoadingExport} onClick={onExport} type={'primary'}><ExportOutlined/> Экспорт</ButtonAntd>
                </div>
            </div>
            <Table loading={isLoading} onChange={handleTableChange} columns={columns} dataSource={dataSource}
                   pagination={false}></Table>
            <div className={'pt-3'}>
                <Pagination defaultCurrent={page} showSizeChanger={true}
                            onShowSizeChange={(current, size) => setPageSize(size)} pageSize={pageSize}
                            onChange={onPaginate} total={total}/>
            </div>
        </div>
    </>
}


export default StatisticPage;
